import script from "./TableData.vue?vue&type=script&setup=true&lang=js"
export * from "./TableData.vue?vue&type=script&setup=true&lang=js"

import "./TableData.vue?vue&type=style&index=0&id=04baf16e&lang=scss"

const __exports__ = script;

export default __exports__